export default __webpack_public_path__ + "static/media/logo.8bbd68b1.svg";